import { get } from 'lodash-es';
import { getCurrentDate } from 'client/site-modules/shared/utils/date-utils';

export function getDeprecationYears(tcoStyle, year) {
  const totalCash = get(tcoStyle, 'totalCash', 0);
  const depreciationYears = Object.values(get(tcoStyle, 'years', {})).map((depYearObj, depYear) => ({
    year: year + depYear + 1,
    depreciation: depYearObj.depreciation,
    active: getCurrentDate().getFullYear() === parseInt(year + depYear + 1, 10),
  }));
  let cash = totalCash;
  depreciationYears.forEach((depYear, key) => {
    cash -= depYear.depreciation;
    depreciationYears[key].price = cash;
  });
  return depreciationYears;
}
